import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["settings", "input"];

  toggle(event) {
    event.preventDefault();
    event.stopPropagation();

    const show = this.inputTarget.value === "true";
    this.inputTarget.value = !show;
    this.settingsTarget.style.display = !show ? "block" : "none";
  }
}